var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "PrivacyPolicy" } },
    [
      _c("appModal", {
        ref: "appModalRef",
        attrs: { countries: _vm.DBCountries }
      }),
      _c("appHeader", {
        attrs: { bgColor: "blue", page: "privacy" },
        on: { headerMenuClicked: _vm.menuClicked }
      }),
      _vm._m(0),
      _c("appFooter"),
      _c("cookiesConsent")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "main_inner" }, [
        _c("section", { staticClass: "main_section" }, [
          _c("div", { staticClass: "section_content" }, [
            _c("h2", { staticClass: "text_subtitle" }, [_vm._v("-")]),
            _c("h1", { staticClass: "title_page text_title2" }, [
              _vm._v(
                "\n                        PRIVACY POLICY AND TERMS OF USE\n                    "
              )
            ]),
            _c(
              "div",
              {
                staticClass: "text_subtitle",
                staticStyle: { "margin-top": "40px" }
              },
              [
                _vm._v(
                  "\n                        WHAT INFORMATION DOES THE WEBSITE COLLECT?\n                    "
                )
              ]
            ),
            _c(
              "p",
              { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
              [
                _c("span", { staticClass: "bolder" }, [
                  _vm._v("Non-personally identifiable information")
                ]),
                _c("br"),
                _c(
                  "u",
                  {
                    staticStyle: {
                      "margin-top": "20px",
                      display: "inline-block"
                    }
                  },
                  [_vm._v("Cookies:")]
                ),
                _c("br"),
                _vm._v(
                  "\n                        A cookie is a small bit of code stored on your computer’s hard drive. When visiting our website, some information may be stored in the “Cookies” files installed in your computer, tablet or mobile phone. This information is gathered so that we can better understand the usage of its sites, and improve and develop them. None of this information can be used to identify individual site visitors, the cookie only identifies the browser of your device. The cookie file allows the transmitter to recognize the terminal every time it accesses the digital content containing cookies from the same transmitter, and can only be read by it."
                ),
                _c("br"),
                _c("br"),
                _c("u", [_vm._v("Technical cookies:")]),
                _c("br"),
                _vm._v(
                  "\n                        They are necessary for browsing our website and in particular allow you to recognize you, to report your visit on different pages and thus improve your browsing comfort by adapting the presentation of the site to the display preferences of your terminal, especially regarding the language used."
                ),
                _c("br"),
                _c("br"),
                _c("u", [_vm._v("Audience cookies:")]),
                _vm._v(
                  "\n                        It measure the audience of the content and topics on our site, in order to evaluate and better organize them. These cookies produce only anonymous statistics and attendance volumes, excluding any individual information. Cookies are activated. Uncheck this box to disable them.\n                    "
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "text_subtitle",
                staticStyle: { "margin-top": "40px" }
              },
              [
                _vm._v(
                  "\n                        “LINKED SITES” OR HYPERLINKS\n                    "
                )
              ]
            ),
            _c(
              "p",
              { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
              [
                _vm._v(
                  "\n                        Some pages of our website may contain external links to other websites, allowing certain content of our site to be linked to similar thematic content hosted on other websites (Hyperlinks). We do not accept any responsibility for the privacy practices of these linked websites or any external company that may collect this data. We encourage you to consult and read the privacy policy of each of these sites to understand how the data collected is used and protected.\n                    "
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "text_subtitle",
                staticStyle: { "margin-top": "40px" }
              },
              [
                _vm._v(
                  "\n                        WHAT ARE MY PRIVACY RIGHTS?\n                    "
                )
              ]
            ),
            _c(
              "p",
              { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
              [
                _vm._v(
                  "\n                        You have the right to access, modify, correct and delete your personal data at any time (art. 34 of the French Data protection act). To do so, contact us at: "
                ),
                _c(
                  "a",
                  { attrs: { href: "mailto:contact.atlas@taxobservatory.eu" } },
                  [_vm._v("contact.atlas@taxobservatory.eu")]
                )
              ]
            ),
            _c(
              "p",
              { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
              [
                _vm._v(
                  "\n                        At any time, you can unsubscribe from our emails, by following the “unsubscribe” instructions near the bottom of the email. You can also email us at: "
                ),
                _c(
                  "a",
                  { attrs: { href: "mailto:contact.atlas@taxobservatory.eu" } },
                  [_vm._v("contact.atlas@taxobservatory.eu")]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "text_subtitle",
                staticStyle: { "margin-top": "40px" }
              },
              [
                _vm._v(
                  "\n                        WEB HOSTING PROVIDER:\n                    "
                )
              ]
            ),
            _c(
              "p",
              { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
              [
                _vm._v("\n                        DigitalOcean"),
                _c("br"),
                _vm._v(
                  "\n                        101 Avenue of the Americas, New York 10013, United States of America"
                ),
                _c("br"),
                _vm._v(
                  "\n                        Tél : +33 (0)8 203 203 63 / E-mail : contact@digitalocean.com"
                ),
                _c("br"),
                _vm._v(
                  "\n                        Server location: Frankfurt, Germany\n                    "
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "text_subtitle",
                staticStyle: { "margin-top": "40px" }
              },
              [
                _vm._v(
                  "\n                        CONTACTS\n                    "
                )
              ]
            ),
            _c(
              "p",
              { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
              [
                _vm._v(
                  "\n                        Publications coordination: Pierre Bachas"
                ),
                _c("br"),
                _vm._v(
                  "\n                        Website coordination: Idann Gidron"
                ),
                _c("br"),
                _vm._v("\n                        Data Protection: "),
                _c("a", { attrs: { href: "mailto:dpd.demandes@cnrs.fr" } }, [
                  _vm._v("dpd.demandes@cnrs.fr")
                ])
              ]
            ),
            _c("br"),
            _c("br"),
            _c("br")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6119ea5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6119ea5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/privacy-policy/index.vue
// module id = jue4
// module chunks = 4